import { Link } from "react-router-dom";
import { MapPin, ArrowRight } from "lucide-react";
import { SEO } from "../components/SEO";
import { SectionHeading, Reveal } from "../components/Reveal";
import { CTABand } from "../components/CTABand";
import { LOCATIONS } from "../data/locations";

export default function ServiceAreas() {
  return (
    <>
      <SEO
        title="Service Areas | Mobile Brake Replacement in Middlesex County MA & Southern NH"
        description="Mobile brake replacement in Dracut, Lowell, Chelmsford, Tyngsboro, Billerica MA and Nashua, Hudson, Pelham NH — plus surrounding towns. We come to you."
        path="/service-areas"
      />
      <section className="border-b border-edge">
        <div className="mx-auto max-w-7xl px-4 py-16 sm:px-6 sm:py-24">
          <SectionHeading
            eyebrow="Service Areas"
            title="Where We Come to You"
            sub="Our core territory is Middlesex County, Massachusetts and Southern New Hampshire. Pick your town for local details — or just request a quote from anywhere nearby."
          />
        </div>
      </section>
      <section data-testid="service-areas-grid" className="mx-auto max-w-7xl px-4 py-16 sm:px-6 sm:py-20">
        <div className="grid gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {LOCATIONS.map((l, i) => (
            <Reveal key={l.slug} delay={(i % 4) * 0.07}>
              <Link
                to={`/${l.slug}`}
                data-testid={`area-${l.city.toLowerCase()}-card`}
                className="group flex h-full flex-col border border-edge bg-slate2 p-6 transition-all duration-300 hover:-translate-y-1 hover:border-amber2/60"
              >
                <div className="flex items-center justify-between">
                  <MapPin className="h-6 w-6 text-crimson" />
                  <span className="font-mono text-[10px] uppercase tracking-widest text-slate-500">{l.state}</span>
                </div>
                <h2 className="mt-4 font-display text-3xl font-black uppercase tracking-tight text-slate-50">
                  {l.city}
                </h2>
                <p className="mt-2 line-clamp-3 flex-1 text-sm leading-relaxed text-slate-400">
                  {l.intro.split(".")[0]}.
                </p>
                <span className="mt-4 flex items-center gap-1.5 font-mono text-xs uppercase tracking-widest text-amber2">
                  Mobile brakes in {l.city} <ArrowRight className="h-3.5 w-3.5 transition-transform group-hover:translate-x-1" />
                </span>
              </Link>
            </Reveal>
          ))}
        </div>
        <Reveal className="mt-10 border border-edge bg-slate2 p-6 text-center">
          <p className="text-sm text-slate-300">
            Just outside these towns? We regularly serve surrounding communities across the
            Merrimack Valley. Request a quote with your ZIP code and we'll confirm coverage right away.
          </p>
        </Reveal>
      </section>
      <CTABand />
    </>
  );
}
